import Vue from 'vue';
import _ from 'lodash';
import axios from 'axios';

// On the page's own host, not homeUrl(): the PHP session and the pending
// BankID state are host-only, so Mina sidor opens where the login ran.
var MINA_SIDOR_PATH = '/mina-sidor/';

jQuery(document).ready(function() {
	window.searchCommonData = {
		pages: [],
		activePages: [],
		searchQuery: '',
		loadingSearch: true,
		searchFocus: false,
		selectedSearchItem: false,
		minaSidorOpen: false,
		patientLoggedIn: false,
		patientName: '',
		bankidLogin: {
			qrCode: false,
			orderRef: false,
			qrStartToken: false,
			qrStartSecret: false,
			nbrRuns: 0,
			signingOnSameDevice: false,
			signingOnOtherDevice: false,
			autostartToken: false,
			waitingForSign: false,
			status: '',
			error: false,
			errorMessage: '',
			user: false,
		},
		bankidLoginQrTimeout: null,
		bankidLoginCollectTimeout: null,
		nkLang: localStorage.getItem('nk_lang') || 'sv',
		isSweden: (function() {
			try { return Intl.DateTimeFormat().resolvedOptions().timeZone === 'Europe/Stockholm'; } catch (e) { return false; }
		})(),
	};

	var loginTranslations = {
		sv: {
			loginTitle: 'Logga in med BankID',
			scanDesc: 'Starta BankID-appen i din mobil eller surfplatta och tryck på Skanna QR-kod.',
			enterCode: 'Skriv in din kod eller identifiera med Face ID i BankID-appen.',
			waitingSign: 'Väntar på signering...',
			openingApp: 'Öppnar BankID-appen...',
			or: 'eller',
			sameDevice: 'BankID på denna enhet',
			openBankID: 'Öppna BankID',
			mobileTapDesc: 'Tryck på knappen nedan för att identifiera dig med BankID.',
			mobileEnterCode: 'Skriv in din kod eller identifiera dig i BankID-appen.',
			myPagesIntro: 'På Mina sidor kan du:',
			myPagesList: ['Se och hantera bokningar', 'Kontakta din klinik före eller efter operation för sjukvårdsrådgivning från legitimerad personal'],
			noBankID: 'Har du inte BankID?',
			smsLogin: 'Logga in med SMS-kod',
			orCallUs: 'eller ring oss på',
			noAccount: 'Inloggning utan kundkonto',
			noAccountDesc: 'För att få tillgång till Mina sidor behöver du vara kund eller patient.',
			bookConsultation: 'Boka en konsultation',
			noAccountSuffix: 'eller behandling för att registreras.',
			tryAgain: 'Försök igen',
			errorStart: 'Kunde inte starta BankID. Försök igen.',
			errorConnect: 'Kunde inte ansluta till BankID. Försök igen.',
			errorVerify: 'Kunde inte verifiera BankID. Försök igen.',
			errorFailed: 'BankID-inloggningen misslyckades. Försök igen.',
		},
		en: {
			loginTitle: 'Log in with BankID',
			scanDesc: 'Open the BankID app on your phone or tablet and tap Scan QR code.',
			enterCode: 'Enter your code or identify with Face ID in the BankID app.',
			waitingSign: 'Waiting for verification...',
			openingApp: 'Opening BankID app...',
			or: 'or',
			sameDevice: 'BankID on this device',
			openBankID: 'Open BankID',
			mobileTapDesc: 'Tap the button below to identify yourself with BankID.',
			mobileEnterCode: 'Enter your code or identify yourself in the BankID app.',
			myPagesIntro: 'On My pages you can:',
			myPagesList: ['View and manage bookings', 'Contact your clinic before or after surgery for healthcare advice from licensed staff'],
			noBankID: "Don't have BankID?",
			smsLogin: 'Log in with SMS code',
			orCallUs: 'or call us at',
			noAccount: 'Login without account',
			noAccountDesc: 'To access My pages you need to be a customer or patient.',
			bookConsultation: 'Book a consultation',
			noAccountSuffix: 'or treatment to register.',
			tryAgain: 'Try again',
			errorStart: 'Could not start BankID. Please try again.',
			errorConnect: 'Could not connect to BankID. Please try again.',
			errorVerify: 'Could not verify BankID. Please try again.',
			errorFailed: 'BankID login failed. Please try again.',
		}
	};

	window.searchCommonComputed = {
		loginT: function () {
			return loginTranslations[this.nkLang] || loginTranslations.sv;
		}
	};

	window.searchCommonMethods = {
		setNkLang(lang) {
			this.nkLang = lang;
			try { localStorage.setItem('nk_lang', lang); } catch (e) {}
		},
		getPages() {
			if (window.profetPreload && window.profetPreload.searchdata) {
				this.pages = window.profetPreload.searchdata;
				this.loadingSearch = false;
				this.convertStringsToInts();
			} else {
				axios.get('/wp-json/nk/getSearchData/').then((response) => {
					this.pages = response.data.data;
					this.loadingSearch = false;
					this.convertStringsToInts();
				});
			}
		},

		changeSelectedSearchTerm(direction) {
			if (direction == 'up') {
				if (this.selectedSearchItem === false) {
					this.selectedSearchItem = 0;
				} else if (this.selectedSearchItem == 0) {
					this.selectedSearchItem = this.activePages.length - 1;
				} else {
					this.selectedSearchItem = this.selectedSearchItem - 1;
				}
			}
			if (direction == 'down') {
				if (this.selectedSearchItem >= this.activePages.length - 1) {
					this.selectedSearchItem = 0;
				} else if (this.selectedSearchItem === false) {
					this.selectedSearchItem = 0;
				} else {
					this.selectedSearchItem = this.selectedSearchItem + 1;
				}
			}
		},

		convertStringsToInts() {
			for (var page in this.pages) {
				/* Set the search_points to an integer */
				this.pages[page].search_points = parseInt(this.pages[page].search_points, 10);

				/* Set all the search_points on the indications to integers */
				for (var indication in this.pages[page].indications) {
					this.pages[page].indications[indication].search_points = parseInt(this.pages[page].indications[indication].search_points, 10);
				}
			}
		},

		hideSearch(event) {
			var self = this;

			setTimeout(function() {
				self.searchFocus = false;
			}, 200);
		},

		orderSearchResultsByPoints() {
			/* Order active search results by calculatedSearchPoints */
			this.activePages = _.sortBy(this.activePages, (o) => o.calculatedSearchPoints).reverse();
		},

		goToSelectedSearchTerm() {
			event.preventDefault();
			var ref = this.$refs['search-term-' + this.selectedSearchItem];
			ref[0].click();
		},

		toggleMinaSidor() {
			if (this.patientLoggedIn) {
				window.location.href = MINA_SIDOR_PATH;
				return;
			}
			if (this.minaSidorOpen) {
				this.closeMinaSidor();
			} else {
				this.openMinaSidor();
			}
		},

		// The QR code only on desktop. On mobile the dropdown waits for
		// "Öppna BankID", which signs on the same device.
		openMinaSidor() {
			this.minaSidorOpen = true;
			if (window.innerWidth >= 992) {
				this.startBankIDLoginQR();
			}
		},

		closeMinaSidor() {
			this.minaSidorOpen = false;
			this.cancelBankIDLogin();
		},

		startBankIDLoginQR() {
			this.bankidLogin.signingOnOtherDevice = true;
			this.bankidLogin.signingOnSameDevice = false;
			this.bankidLogin.nbrRuns = 0;
			this.bankidLogin.error = false;
			this.bankidLogin.errorMessage = '';
			this.bankidLogin.waitingForSign = false;
			this.authenticateBankIDLogin(0);
		},

		authenticateBankIDLogin(nbrOfRuns) {
			var self = this;
			var postData = {
				nbrOfRuns: nbrOfRuns,
				bookingData: null,
			};
			if (nbrOfRuns > 0 && self.bankidLogin.qrStartToken) {
				postData.qrData = {
					orderRef: self.bankidLogin.orderRef,
					qrStartToken: self.bankidLogin.qrStartToken,
					qrStartSecret: self.bankidLogin.qrStartSecret,
				};
			}
			axios.post('/wp-json/nk/cb/authenticate/', postData).then(function(response) {
				if (!self.minaSidorOpen) return;
				var data = response.data.data;
				if (data.error) {
					self.bankidLogin.error = true;
					self.bankidLogin.errorMessage = data.message || self.loginT.errorStart;
					return;
				}
				self.bankidLogin.orderRef = data.orderRef;
				if (data.qrStartToken) {
					self.bankidLogin.qrStartToken = data.qrStartToken;
					self.bankidLogin.qrStartSecret = data.qrStartSecret;
				}
				self.bankidLogin.qrCode = 'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=' + data.qrString;
				self.bankidLogin.nbrRuns = nbrOfRuns;

				if (nbrOfRuns === 0) {
					self.collectBankIDLogin();
				}

				self.bankidLoginQrTimeout = setTimeout(function() {
					if (!self.minaSidorOpen) return;
					self.authenticateBankIDLogin(nbrOfRuns + 1);
				}, 1000);
			}).catch(function() {
				self.bankidLogin.error = true;
				self.bankidLogin.errorMessage = self.loginT.errorConnect;
			});
		},

		collectBankIDLogin() {
			var self = this;
			axios.get('/wp-json/nk/patient/collectBankIDLogin/', {
				params: { orderRef: self.bankidLogin.orderRef }
			}).then(function(response) {
				if (!self.minaSidorOpen) return;
				var data = response.data.data;
				if (data.status === 'pending') {
					if (data.hint === 'userSign') {
						self.bankidLogin.waitingForSign = true;
					}
					self.bankidLoginCollectTimeout = setTimeout(function() {
						self.collectBankIDLogin();
					}, 2000);
				} else if (data.status === 'complete') {
					self.onBankIDLoginComplete(data);
				} else if (data.status === 'failed' || data.error) {
					self.bankidLogin.error = true;
					self.bankidLogin.errorMessage = data.message || self.loginT.errorFailed;
					self.resetBankIDLogin();
				}
			}).catch(function() {
				self.bankidLogin.error = true;
				self.bankidLogin.errorMessage = self.loginT.errorVerify;
			});
		},

		startBankIDLoginSameDevice() {
			var self = this;
			this.bankidLogin.signingOnSameDevice = true;
			this.bankidLogin.signingOnOtherDevice = false;
			this.bankidLogin.qrCode = false;
			this.bankidLogin.error = false;
			this.bankidLogin.errorMessage = '';

			clearTimeout(this.bankidLoginQrTimeout);
			clearTimeout(this.bankidLoginCollectTimeout);

			axios.post('/wp-json/nk/cb/initiateBankIDAuth/', {
				sameDevice: true,
				bookingData: null,
			}).then(function(response) {
				if (!self.minaSidorOpen) return;
				var data = response.data.data;
				if (data.error) {
					self.bankidLogin.error = true;
					self.bankidLogin.errorMessage = self.loginT.errorStart;
					return;
				}
				self.bankidLogin.orderRef = data.orderRef;
				self.bankidLogin.autostartToken = data.autostartToken;

				var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
				var redirect = isIOS ? encodeURIComponent(window.location.origin + MINA_SIDOR_PATH) : 'null';
				var url = 'bankid:///?autostarttoken=' + data.autostartToken + '&redirect=' + redirect;

				localStorage.setItem('nk_bankid_login_pending', '1');
				localStorage.setItem('nk_bankid_order_ref', data.orderRef);
				document.cookie = 'nk_bankid_pending=1;path=/;max-age=120';
				window.location.href = url;

				self.collectBankIDLogin();
			}).catch(function() {
				self.bankidLogin.error = true;
				self.bankidLogin.errorMessage = self.loginT.errorConnect;
			});
		},

		onBankIDLoginComplete(data) {
			this.patientLoggedIn = true;
			this.patientName = data.user.first_name;
			this.resetBankIDLogin();
			this.minaSidorOpen = false;
			localStorage.removeItem('nk_bankid_login_pending');
			localStorage.removeItem('nk_bankid_order_ref');
			document.cookie = 'nk_bankid_pending=;path=/;max-age=0';
			localStorage.removeItem('nk_cb_patient_id');
			window.location.href = MINA_SIDOR_PATH;
		},

		cancelBankIDLogin() {
			var self = this;
			clearTimeout(this.bankidLoginQrTimeout);
			clearTimeout(this.bankidLoginCollectTimeout);

			if (this.bankidLogin.orderRef) {
				axios.get('/wp-json/nk/cb/cancelBankIDOrder/', {
					params: { orderRef: self.bankidLogin.orderRef }
				}).catch(function() {});
			}
			localStorage.removeItem('nk_bankid_login_pending');
			localStorage.removeItem('nk_bankid_order_ref');
			this.resetBankIDLogin();
		},

		resetBankIDLogin() {
			clearTimeout(this.bankidLoginQrTimeout);
			clearTimeout(this.bankidLoginCollectTimeout);
			this.bankidLogin.qrCode = false;
			this.bankidLogin.orderRef = false;
			this.bankidLogin.nbrRuns = 0;
			this.bankidLogin.signingOnSameDevice = false;
			this.bankidLogin.signingOnOtherDevice = false;
			this.bankidLogin.autostartToken = false;
			this.bankidLogin.waitingForSign = false;
			this.bankidLogin.status = '';
		},

		checkPatientLoginStatus() {
			var self = this;
			return axios.get('/wp-json/nk/patient/checkLoginStatus/').then(function(response) {
				var data = response.data.data;
				if (data.logged_in) {
					self.patientLoggedIn = true;
					self.patientName = data.first_name;

					if (localStorage.getItem('nk_bankid_login_pending')) {
						localStorage.removeItem('nk_bankid_login_pending');
						localStorage.removeItem('nk_bankid_order_ref');
						window.location.href = MINA_SIDOR_PATH;
					}
				} else {
					var pendingOrderRef = localStorage.getItem('nk_bankid_order_ref');
					if (pendingOrderRef) {
						self.bankidLogin.orderRef = pendingOrderRef;
						self.resumeBankIDLoginCollect();
					}
				}
			}).catch(function() {});
		},

		resumeBankIDLoginCollect() {
			var self = this;
			axios.get('/wp-json/nk/patient/collectBankIDLogin/', {
				params: { orderRef: self.bankidLogin.orderRef }
			}).then(function(response) {
				var data = response.data.data;
				if (data.status === 'complete') {
					localStorage.removeItem('nk_bankid_login_pending');
					localStorage.removeItem('nk_bankid_order_ref');
					self.patientLoggedIn = true;
					self.patientName = data.user.first_name;
					window.location.href = MINA_SIDOR_PATH;
				} else if (data.status === 'pending') {
					setTimeout(function() {
						self.resumeBankIDLoginCollect();
					}, 2000);
				} else {
					localStorage.removeItem('nk_bankid_login_pending');
					localStorage.removeItem('nk_bankid_order_ref');
				}
			}).catch(function() {
				localStorage.removeItem('nk_bankid_login_pending');
				localStorage.removeItem('nk_bankid_order_ref');
			});
		},

		doSearch(event) {
			/* If it's a up arrow or down arrow key press, don't make a new search */
			if (event.which == 38 || event.which == 40) {
				return;
			}

			this.selectedSearchItem = false;

			this.activePages = [];
			var query = this.searchQuery.toLowerCase();

			if (this.searchQuery.length > 1) {
				for (var page in this.pages) {
					var multiplier = 1;

					var pushToActive = false;
					/* Set the search score to 0 by default */
					this.pages[page].calculatedSearchPoints = 0;
					var pageTitle = this.pages[page].title.toLowerCase();

					/*if(pageTitle.indexOf(query) !== -1) {*/
					if (pageTitle.indexOf(query) !== -1) {
						pushToActive = true;

						if (pageTitle.substring(0, query.length) == query) {
							/* If the search matches the full starting characters of the page title, and the page has less than 100 search points, set the search points to 100 to automatically float the result high up */
							if (this.pages[page].calculatedSearchPoints < 100) {
								this.pages[page].calculatedSearchPoints = 100;
							}

							multiplier *= 1.8;
						}

						/* If the search matches exactly, give 200 search points */
						if (pageTitle == query) {
							multiplier = 2;
						}

						/* Add points based on how many percent of the title the search query matches */
						if (pageTitle.substring(0, query.length) == query) {
							var percentageMatch = query.length / pageTitle.length;
							percentageMatch *= 100;
							percentageMatch = Math.round(percentageMatch);
							this.pages[page].calculatedSearchPoints += percentageMatch;
						}

						var splitString = pageTitle.split(' ');
						for (var s in splitString) {
							if (splitString[s].substring(0, query.length) == query) {
								if (multiplier == 1) {
									multiplier *= 1.3;
								}
							}
						}

						if (this.pages[page].search_points > this.pages[page].calculatedSearchPoints) {
							this.pages[page].calculatedSearchPoints = this.pages[page].search_points;
						}
					}

					/* Check if any of the search tags match */
					if (this.pages[page].search_tags != undefined) {
						for (var tag in this.pages[page].search_tags) {
							var searchTag = this.pages[page].search_tags[tag].name.toLowerCase();
							/*if(searchTag.indexOf(query) !== -1) {*/
							if (searchTag.substring(0, query.length) == query) {
								pushToActive = true;
								if (this.pages[page].search_tags[tag].search_points > this.pages[page].calculatedSearchPoints) {
									this.pages[page].calculatedSearchPoints = this.pages[page].search_tags[tag].search_points;

									if (multiplier != 1) {
										multiplier = 1.1;
									}
								}
							}
						}
					}

					/* Check if any of the indications match */
					if (this.pages[page].indications != undefined) {
						for (var indication in this.pages[page].indications) {
							var indicationName = this.pages[page].indications[indication].name.toLowerCase();
							/*if(indicationName.indexOf(query) !== -1) {*/
							if (indicationName.substring(0, query.length) == query) {
								pushToActive = true;
								if (this.pages[page].indications[indication].search_points > this.pages[page].calculatedSearchPoints) {
									this.pages[page].calculatedSearchPoints = this.pages[page].indications[indication].search_points;
								}
							}
						}
					}

					/* Lower score for anything that isn't a page */
					if (this.pages[page].post_type == 'post') {
						//pushToActive = false;
						multiplier *= 0.95;
					}

					if (pushToActive) {
						if (this.pages[page].calculatedSearchPoints < 20 && multiplier > 1.3) {
							this.pages[page].calculatedSearchPoints = 50;
						}

						this.pages[page].calculatedSearchPoints *= multiplier;
						this.activePages.push(this.pages[page]);
					}
				}

				this.orderSearchResultsByPoints();
			}
		},
	};

	new Vue({
		el: '#header-desktop',

		data: window.searchCommonData,

		methods: window.searchCommonMethods,

		computed: Object.assign({}, window.searchCommonComputed, {
			showPopularSearches() {
				if (this.searchFocus == true && this.searchQuery.length == 0 && this.activePages.length == 0) {
					return true;
				}
				return false;
			},
			searchIsActive() {
				if (this.searchQuery.length > 0 || this.searchFocus) {
					return true;
				}
				return false;
			},
		}),

		created() {
			this.getPages();
			var loginStatus = this.checkPatientLoginStatus();

			if (window.location.search.indexOf('sign_in=1') !== -1) {
				var self = this;
				// After the status check, so a patient who is already logged in
				// goes to Mina sidor instead of getting a new login.
				loginStatus.then(function () {
					if (self.patientLoggedIn) {
						window.location.href = MINA_SIDOR_PATH;
						return;
					}
					self.openMinaSidor();
				});
			}

			document.onkeydown = (e) => {
				if (e.keyCode === 27 && this.minaSidorOpen) {
					this.closeMinaSidor();
					return;
				}
				var tag = e.target && e.target.tagName ? e.target.tagName.toLowerCase() : '';
				if (tag === 'textarea') return;
				switch (e.keyCode) {
					case 13:
						this.goToSelectedSearchTerm();
						break;
					case 38:
						this.changeSelectedSearchTerm('up');
						break;
					case 40:
						this.changeSelectedSearchTerm('down');
						break;
				}
			};
		},
	});

	new Vue({
		el: '#header-mobile',

		data: window.searchCommonData,

		computed: Object.assign({}, window.searchCommonComputed, {
			showPopularSearches() {
				if (this.searchFocus == true && this.searchQuery.length == 0 && this.activePages.length == 0) {
					return true;
				}
				return false;
			},
			searchIsActive() {
				if (this.searchFocus) {
					return true;
				}
				return false;
			},
		}),

		methods: window.searchCommonMethods,
	});
});
